import { Pipe, PipeTransform } from '@angular/core';
import {DateTime, DurationLike, DurationUnit} from "luxon";

@Pipe({
  name: 'dateDiff'
})
export class DateDiffPipe implements PipeTransform {
  transform(from: Date, to: Date, unit: DurationUnit, roundTo?: DurationLike): number {
    let duration = DateTime.fromJSDate(to).diff(DateTime.fromJSDate(from), unit);
    roundTo = roundTo ?? {day: 0};
    let number = Math.ceil(duration.as(unit));
    let number1 = Math.ceil(duration.minus(roundTo).as(unit));
    if(number > number1){
      return number1
    }
    return number;
  }
}
